// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__39yIP","content":"styles_content__2PxIH","checkbox":"styles_checkbox__3OyIE","checkboxLabel":"styles_checkboxLabel__1sNHv"};